<p-dialog
  [visible]="visible()"
  (visibleChange)="onVisibleChange($event)"
  (onShow)="onShow()"
  [modal]="true"
  [dismissableMask]="false"
  [closable]="!submitting()"
  [closeOnEscape]="!submitting()"
  [draggable]="false"
  [style]="{ width: '480px' }"
  [breakpoints]="{ '520px': 'calc(100vw - 2rem)' }"
>
  <ng-template #header>
    <div class="flex items-center gap-3">
      <span class="cancel-dialog-icon">
        <i class="ph ph-x-circle text-2xl"></i>
      </span>
      <span class="text-xl font-bold">
        Cancelar pedido #{{ order()?.number }}
      </span>
    </div>
  </ng-template>

  <form [formGroup]="form" (ngSubmit)="submit()" class="flex flex-col gap-4">
    <p>
      Você quer cancelar o pedido de
      <span class="font-bold">{{ order()?.customer?.fullName }}</span
      >?
    </p>

    <div class="cancel-dialog-alert">
      <i class="ph ph-warning text-xl"></i>
      <div class="flex flex-col gap-1">
        <p class="font-bold">Esta ação não pode ser desfeita</p>
        @if (downPaymentRefundable()) {
          <p>
            O valor da entrada,
            <span class="font-bold">{{ downPaymentAmount() | currency }}</span
            >, será estornado
            @if (card()) {
              para o cartão
              <span class="font-bold"
                >{{ card()!.brand | titlecase }} ••••
                {{ card()!.displayNumber }}</span
              >
              do cliente.
            } @else {
              para o cartão do cliente.
            }
          </p>
        }
        <p>
          Depois do cancelamento, o pedido não pode ser reativado e fica
          disponível só para consulta.
        </p>
      </div>
    </div>

    <div class="flex flex-col gap-2">
      <label class="text-sm font-semibold" for="cancel-reason">
        Motivo do cancelamento *
      </label>
      <p-select
        inputId="cancel-reason"
        formControlName="reasonId"
        [options]="reasons()"
        optionLabel="label"
        optionValue="value"
        placeholder="Selecione o motivo"
        [loading]="reasonsLoading()"
        [invalid]="invalidReason()"
        (onChange)="onReasonChange()"
        class="w-full"
        appendTo="body"
      ></p-select>
      @if (invalidReason()) {
        <small class="p-error">Motivo inválido. Selecione outro motivo.</small>
      }
      @if (reasonsError()) {
        <div class="flex items-center gap-2">
          <small class="p-error"
            >Não foi possível carregar os motivos. Tente novamente.</small
          >
          <p-button
            type="button"
            label="Tentar novamente"
            size="small"
            [text]="true"
            (onClick)="loadReasons()"
          ></p-button>
        </div>
      }
    </div>

    <div class="flex flex-col gap-2">
      <label class="text-sm font-semibold" for="cancel-details">
        Justificativa (opcional)
      </label>
      <textarea
        id="cancel-details"
        pTextarea
        formControlName="additionalDetails"
        rows="4"
        [attr.maxlength]="detailsMaxLength"
        class="w-full"
        placeholder="Conte o motivo do cancelamento"
      ></textarea>
      <div class="flex justify-between text-sm text-gray-500">
        <span>Fica registrada nos detalhes do pedido.</span>
        <span>{{ detailsLength }}/{{ detailsMaxLength }}</span>
      </div>
    </div>

    <div class="flex justify-end gap-2 mt-2">
      <p-button
        type="button"
        label="Voltar"
        severity="secondary"
        rounded
        class="btn-secondary-outline"
        [disabled]="submitting()"
        (onClick)="close()"
      ></p-button>
      <p-button
        type="submit"
        label="Cancelar"
        severity="danger"
        rounded
        [disabled]="form.invalid"
        [loading]="submitting()"
      ></p-button>
    </div>
  </form>
</p-dialog>
